import { Badge, Group, MultiSelect, MultiSelectProps, rem } from '@mantine/core'
import { IconCheck } from '@tabler/icons-react'
import { forwardRef } from 'react'
import classes from './ObjectMultiSelect.module.css'
import { LabelOption } from './ObjectSelect'

export const ObjectMultiSelect = forwardRef<HTMLInputElement, MultiSelectProps>(
  (props, ref) => {
    const { value, placeholder } = props

    return (
      <MultiSelect
        size="xs"
        classNames={{ pill: classes.pill }}
        maxDropdownHeight={300}
        comboboxProps={{
          width: 320,
          position: 'bottom-start'
        }}
        styles={{
          pill: {
            backgroundColor: 'transparent',
            paddingInline: '0 8px',
            fontSize: rem(12),
            fontWeight: 'bold',
            textTransform: 'uppercase'
          },
          inputField: {
            fontSize: rem(12),
            fontWeight: 'bold',
            textTransform: 'uppercase'
          }
        }}
        renderOption={({ option, checked }) => {
          const { label, color } = option as LabelOption

          return (
            <Group flex="1" gap="xs">
              <Badge color={color} size="sm">
                {label}
              </Badge>

              {checked && (
                <IconCheck style={{ marginInlineStart: 'auto' }} size={16} />
              )}
            </Group>
          )
        }}
        {...props}
        ref={ref}
        placeholder={!value || value.length === 0 ? placeholder : undefined}
      />
    )
  }
)

ObjectMultiSelect.displayName = 'ObjectMultiSelect'
